<template>
  <div class="container1">
    <BetterScroll class="top_title" :scrollX="true" :data="cityList" v-if="true" ref="wrapper1">
      <div class="wrapper1">
        <div
          class="item"
          v-for="(item,index) in cityList"
          :key="index"
          :class="{'item_active':item.select}"
          @click="changeCity(item,index)"
        >
          <p :class="{'p_active':item.select}">{{item.areaName}}</p>
          <p>
            <span :class="{'t_active':item.select}">{{item.num}}</span>
            <span :class="{'t_active':item.select}">起</span>
          </p>
        </div>
      </div>
    </BetterScroll>
    <div class="pro_detail">
      <div class="all_city" v-if="true" ref="allCity" :class="{'all_active':isShow}">
        <p class="t_txt">全部地区</p>
        <div class="pro1">
          <div class="pro_item">
            <div
              class="pro"
              v-for="(item,index) in cityList"
              :key="index"
              :class="{'pro_active':item.select}"
              @click="changeCity(item,index)"
            >
              <p :class="{'p_active':item.select}">{{item.areaName}}</p>
              <p>
                <span :class="{'t_active':item.select}">{{item.num}}</span>
                <span :class="{'t_active':item.select}">起</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content_list">
      <div class="s_city" @click="changShow()">
        <img src="../../../../assets/image/select.png" v-if="!isShow" />
        <img src="../../../../assets/image/no_select.png" v-if="isShow" />
      </div>
      <div class="pro_item">
        <div class="item_left">
          <div class="left">
            <p class="status">{{cityName}}<i>(起)</i></p>
            <div class="num">
              <span>{{total}}</span>
              <span></span>
            </div>
          </div>
          <div class="center"></div>
          <div class="left">
            <p class="status">退货总金额<span v-if="parseInt(totalPrice)<10000">(元)</span>
              <span v-if="parseInt(totalPrice)>=10000&&parseInt(totalPrice)<100000000">(万元)</span>
              <span v-if="parseInt(totalPrice)>=100000000">(亿)</span></p>
            <div class="num">
              <span>{{totalPrice|filt3}}</span>
              <span></span>
            </div>
          </div>
        </div>
        <div class="line"></div>
      </div>
      <van-list
        ref="vanList"
        v-model="loading"
        :finished="finished"
        :finished-text="finishedText"
        @load="onLoad"
        class="wrapper"
      >
        <div
          class="reject"
          v-for="(item,index) in proList"
          :key="index"
          @click="goDetail(item.flowId)"
        >
          <div class="reject_item">
            <div class="item_box">
              <p class="title_text">{{item.product}}</p>
              <div class="info">
                <span class="orign">所属区域:</span>
                <span class="t_orign">{{item.geography}}</span>
                <!-- <span class="t_orign">我是一个测试地址，你看一下，外行暗黑风哈哈符号</span> -->
              </div>
              <div class="info">
                <span>商家名称:</span>
                <span>{{item.shoppingStore}}</span>
              </div>
              <div class="info">
                <span>退货人:</span>
                <span>{{item.purchaser}}</span>
              </div>
              <div class="info">
                <span>商品金额:</span>
                <span>{{item.shoppingAmount}}</span>
              </div>
              <div class="info">
                <span>商品类型:</span>
                <span>{{item.productType | filt1}}</span>
              </div>
              <div class="info">
                <span>退货时间:</span>
                <span>{{item.refundTime|filt()}}</span>
              </div>
              <div class="info">
                <span>退货单号:</span>
                <span>{{item.orderNumber}}</span>
              </div>
            </div>
            <div class="line line_bottom"></div>
            <div class="status">
               <span class="left">{{item.centerName}}-{{item.statusText}}</span>
               <div class="right">
                     <span>查看更多</span>
                     <img src="../../../../assets/image/right.png"/>
               </div>
          </div>
          </div>
          <!-- <div class="space"></div> -->
        </div>
      </van-list>
    </div>
    <div class="box1" v-if="isNolist">
      <img src="../../../../assets/empty/ic_wuxingxi.png" />
      <p class="tip1">暂无数据</p>
    </div>
  </div>
</template>
<script>
    import BetterScroll from '../../../../components/base/betterScroll';
    import api from '../../../../service/modules/refund';
    import util from '../../../../utils/common';
    import moment from 'moment';
    export default {
        components: {
            BetterScroll
        },
        data () {
            return {
                isHide: false,
                isShow: false,
                ischange: true,
                cityCode: this.$router.currentRoute.query.cityCode,
                refundType: this.$router.currentRoute.query.refundType,
                startTime: this.$router.currentRoute.query.startTime,
                endTime: this.$router.currentRoute.query.endTime,
                // total:this.$router.currentRoute.query.total,
                // totalprice:this.$router.currentRoute.query.totalprice,
                pageIndex: '1',
                pageSize: '10',
                proList: [],
                cityList: [],
                cityList1: [],
                finished: false,
                finishedText: '没有更多',
                loading: true,
                isNolist: false,
                total: '0',
                totalPrice: '0',
                status: '',
                timer: null,
                scrollY: 0,
                cityName: '',
                cover: 1
            };
        },
        created () {
            this.initDate();
        },
        activated () {
            // this.cityCode = this.$router.currentRoute.query.cityCode;
            // this.refundType = this.$router.currentRoute.query.refundType;
            // this.startTime = this.$router.currentRoute.query.startTime;
            // this.endTime = this.$router.currentRoute.query.endTime;
            // this.finished = false;
            // if (this.refundType === 'processing') {
            //     this.status = -11;
            // } else if (this.refundType === 'refundSuccess') {
            //     this.status = -12;
            // } else if (this.refundType === 'waitAccept') {
            //     this.status = -13;
            // } else if (this.refundType === 'userRevoke') {
            //     this.status = 150;
            // } else if (this.refundType === 'refuseAccept') {
            //     this.status = -14;
            // }
        },
        // beforeRouteEnter (to, from, next) {
        //     next(vm => {
        //         // 通过 `vm` 访问组件实例
        //         if (from.path === '/refund/leaderList') {
        //             // 一定是从A进到B页面才刷新
        //             vm.$refs.wrapper1.scrollTo(0, 0);
        //             console.log(vm.status);
        //             // vm.proList=[];
        //             vm.pageIndex = '1';
        //             // vm.finished=false;
        //             vm.getReturnSort();
        //         } else {
        //         }
        //     });
        // },
        mounted () {
        },
        methods: {
            initDate () {
                if (this.refundType === 'processing') {
                    this.status = -11;
                } else if (this.refundType === 'refundSuccess') {
                    this.status = -12;
                } else if (this.refundType === 'waitAccept') {
                    this.status = -13;
                } else if (this.refundType === 'userRevoke') {
                    this.status = 150;
                } else if (this.refundType === 'refuseAccept') {
                    this.status = -14;
                }
                // this.$refs.wrapper1.scrollTo(0, 0);
                this.getReturnSort();
            },
            changShow () {
                this.isShow = !this.isShow;
            },
            changeCity (item, index) {
                this.loading = false;
                this.finished = false;
                window.scrollTo(0, 0);
                if (item.areaName === '市级' || item.areaName === '省级') {
                    this.cover = 2;
                } else {
                    this.cover = 1;
                }
                this.cityName = item.areaName;
                this.totalPrice = item.amount;
                this.total = item.num;
                this.pageIndex = '1';
                this.cityCode = item.areaCode;

                this.cityList.map((item, index) => {
                    this.$set(item, 'select', false);
                });
                this.$set(this.cityList[index], 'select', true);
                if (index > 3) {
                    var num = item.num;
                    var city = item.areaName;
                    var cityCode = item.areaCode;
                    var amount = item.amount;
                    var num1 = this.cityList[3].num;
                    var city1 = this.cityList[3].areaName;
                    var cityCode1 = this.cityList[3].areaCode;
                    var amount1 = this.cityList[3].amount;
                    this.$set(this.cityList[index], 'num', num1);
                    this.$set(this.cityList[index], 'areaName', city1);
                    this.$set(this.cityList[index], 'areaCode', cityCode1);
                    this.$set(this.cityList[index], 'amount', amount1);
                    this.$set(this.cityList[index], 'select', false);
                    this.$set(this.cityList[3], 'num', num);
                    this.$set(this.cityList[3], 'areaName', city);
                    this.$set(this.cityList[3], 'areaCode', cityCode);
                    this.$set(this.cityList[3], 'amount', amount);
                    this.$set(this.cityList[3], 'select', true);
                    this.$refs.wrapper1.scrollTo(0, 0);
                }
                this.isShow = false;
                this.pageIndex = '1';
                this.getList();
            },
            goDetail (value) {
                this.$store.commit('refund/setFlowId', value);
                util.setJsonLocal('flowId',value);
                this.$router.push('refundDetail?flowId=' + value);
            },
            getReturnSort () {
                api.returnSort({
                    areaId: this.cityCode,
                    startDate: this.startTime,
                    endDate: this.endTime,
                    refundType: this.refundType
                })
                    .then(res => {
                        if (res.ret === 0) {
                            this.cityList = res.data;
                            let totalNum = 0;
                            let totalAmount = 0;
                            res.data.map((item, index) => {
                                totalNum += parseInt(item.num);
                                totalAmount += parseFloat(item.amount);
                            });
                            var obj = {
                                amount: totalAmount,
                                areaCode: this.cityCode,
                                areaName: '全部',
                                num: totalNum
                            };
                            this.cityList.unshift(obj);
                            this.total = res.data[0].num;
                            this.totalPrice = res.data[0].amount;
                            this.cityName = res.data[0].areaName;

                            this.cityList.map((item, index) => {
                                if (this.cityCode == 530000) {
                                    if (index == 1) {
                                        this.$set(this.cityList[index], 'select', true);
                                        if (item.areaName === '市级' || item.areaName === '省级') {
                                            this.cover = 2;
                                        } else {
                                            this.cover = 1;
                                        }
                                        this.cityName = item.areaName;
                                        this.totalPrice = item.amount;
                                        this.total = item.num;
                                    } else {
                                        this.$set(this.cityList[index], 'select', false);
                                    }
                                } else {
                                    if (index == 0) {
                                        this.$set(this.cityList[index], 'select', true);
                                    } else {
                                        this.$set(this.cityList[index], 'select', false);
                                    }
                                }
                            });
                            this.pageIndex = 1;
                            this.getList();
                        }
                    });
            },
            getList () {
                this.pageIndex = 1;
                api
                    .returnList({
                        startDate: this.startTime,
                        endDate: this.endTime,
                        areaId: this.cityCode,
                        pageIndex: this.pageIndex,
                        pageSize: this.pageSize,
                        status: this.status,
                        cover: this.cover
                    })
                    .then(res => {
                        if (res.ret === 0) {
                            if (res.data.list.length > 0) {
                                this.proList = res.data.list;
                                if (this.proList.length === res.data.pageination.total) { // 等于总数量
                                    this.finished = true;
                                    this.loading = false;
                                    this.isNolist = false;
                                } else {
                                    this.finished = false;
                                    this.loading = false;
                                }
                            } else {
                                this.finished = true;
                                this.loading = false;
                                this.isNolist = true;
                            }
                        }
                    });
            },
            onLoad () {
                this.pageIndex++;
                api
                    .returnList({
                        startDate: this.startTime,
                        endDate: this.endTime,
                        areaId: this.cityCode,
                        pageIndex: this.pageIndex,
                        pageSize: this.pageSize,
                        status: this.status,
                        cover: this.cover
                    })
                    .then(res => {
                        if (res.ret === 0) {
                            setTimeout(() => {
                                if (res.data.list.length > 0) {
                                    this.proList = this.proList.concat(res.data.list);
                                    if (this.proList.length === res.data.pageination.total) { // 等于总数量
                                        this.finished = true;
                                        this.loading = false;
                                    } else {
                                        this.finished = false;
                                        this.loading = false;
                                    }
                                } else {
                                    this.finished = true;
                                    this.loading = false;
                                }
                            }, 500);
                        }
                    });
            }
        },
        filters: {
            filt (value) {
                return moment(value).format('YYYY-MM-DD HH:mm:ss');
            },
            filt1 (value) {
                var config = util.getJsonLocal('configList').PRODUCT_TYPE || [];
                let name = '';
                config.forEach((item, index) => {
                    if (item.code === value) {
                        name = item.name;
                    }
                });
                return name;
            },
            filt2 (value) {
                var config = util.getJsonLocal('configList').WORK_ORDER_FLOW;
                let name = '';
                config.map((item, index) => {
                    if (item.code === value) {
                        name = item.name;
                    }
                });
                return name;
            },
            filt3 (value) {
                if (parseInt(value) < 10000) {
                    return value;
                } else if (parseInt(value) >= 10000 && parseInt(value) < 100000000) {
                    return (parseInt(value) / 10000).toFixed(2);
                } else if (parseInt(value) >= 100000000) {
                    return (parseInt(value) / 100000000).toFixed(2);
                }
            }
        }
    };
</script>
<style scoped lang="less">
.container1 {
  width: 100%;
  height: 100%;
  background: #fafafa;
  // padding-top:20px;
  .top_title {
    width: 100%;
    height: 80px;
    // padding:24px 0;
    overflow: hidden;
    position: fixed;
    // padding-top:20px;
    background-color: #fff;
    z-index: 2;
    box-sizing: border-box;
    // box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.04);
    .wrapper1 {
      white-space: nowrap;
      position: absolute;
      top: 0;
      margin-top: 12px;
      .item {
        display: inline-block;
        padding: 0 24px;
        height: 56px;
        border: 1px solid #efefef;
        text-align: center;
        border-radius: 4px;
        margin-left: 10px;
        // display: flex;
        // align-items: center;
        p:nth-child(1) {
          font-size: 12px;
          color: #999999;
          margin-top: 10px
        }
        .p_active {
          color: #fff !important;
        }
        p:nth-child(2) {
          font-size: 18px;
          margin-top: 6px;
          span:nth-child(1) {
            font-size: 18px;
            color: #999999;
            font-size: DIN bold;
          }
          span:nth-child(2) {
            font-size: 12px;
            color: #999999;
          }
          .t_active {
            color: #fff !important;
          }
        }
      }
      .item_active {
        background-color: #36b374;
        border: 1px solid #36b374;
      }
    }
  }
  .pro_detail {
    width: 100%;
    padding-top: 80px;
    .all_city {
      padding-top: 24px;
      width: 100%;
      overflow: hidden;
      position: relative;
      transition: all 0.5s ease-in-out;
      margin-top: -100%;
      background: #fff;
      .t_txt {
        width: 100%;
        text-align: center;
        font-size: 15px;
        color: #000;
        font-weight: 700;
      }
      .pro1 {
        width: 100%;
        padding: 0 16px;
        box-sizing: border-box;
        .pro_item {
          width: 100%;
          font-size: 0;
          margin-top: 12px;
          // border-top:1px solid #efefef;
          border-left: 1px solid #efefef;
          padding-bottom: 1px;
          .pro:nth-child(-n + 5) {
            border-top: 1px solid #efefef;
          }
          .pro {
            display: inline-block;
            width: 20%;
            padding: 10px 0;
            border-right: 1px solid #efefef;
            border-bottom: 1px solid #efefef;
            text-align: center;
            p:nth-child(1) {
              width: 100%;
              height: 25px;
              line-height: 1.1em;
              // overflow: hidden;
              // white-space: nowrap;
              // text-overflow:ellipsis;
              font-size: 12px;
              color: #999999;
              word-break: break-all;
              text-overflow: ellipsis;
              display: -webkit-box;
              /* autoprefixer: off */
              -webkit-box-orient: vertical;
              /* autoprefixer: on */
              -webkit-line-clamp: 2;
              overflow: hidden;
            }
            .p_active {
              color: #fff !important;
            }
            p:nth-child(2) {
              // font-size:16px;
              margin-top: 8px;
              // color:#999999;
              span:nth-child(1) {
                font-size: 18px;
                color: #999999;
                font-weight: bold;
              }
              span:nth-child(2) {
                font-size: 12px;
                color: #999999;
              }
              .t_active {
                color: #fff !important;
              }
            }
          }
          .pro_active {
            background: #36b374;
          }
        }
      }
    }
    .all_active {
      // height:99%;
      margin-top: 0;
      // opacity: 1;
    }
    .s_city {
      width: 100%;
      text-align: center;
      border-bottom: 1px solid #efefef;
      padding-top: 20px;
      background: #fff;
      img {
        display: inline-block;
        width: 100px;
        height: 24px;
      }
    }
  }
  .content_list {
    width: 100%;
    // padding:0 16px;
    // box-sizing: border-box;
    .s_city {
      width: 100%;
      text-align: center;
      border-bottom: 1px solid #efefef;
      padding-top: 8px;
      background: #fff;
      img {
        width: 48px;
        height: 14px;
        margin: 0 auto;
      }
    }
    .pro_item {
      width: 100%;
      padding: 16px 0;
      position: relative;
      background-color: #fafafa;
      .item_left {
        display: flex;
        margin-left: 12px;
        margin-right: 12px;
        display: -webkit-flex;
        align-items: center;
        flex-direction: row;
        box-shadow: 0px 5px 10px 5px rgba(0, 0, 0, 0.04);
        padding:0 10px 12px 10px;
        background-color: #ffffff;
        justify-content: space-between;
        border-radius: 3px;
        .left {
          display: inline-block;
          text-align: center;
          width:45%;
          .num {
            span:nth-child(1) {
              font-size: 32px;
              color: #36b374;
              display: inline-block;
              vertical-align: bottom;
              font-weight: bold;
            }
            span:nth-child(2) {
              font-size: 10px;
              display: inline-block;
              vertical-align: bottom;
              margin-left: 4px;
              margin-top: 43px;
            }
          }
          .status {
            font-size: 14px;
            margin-top: 16px;
            color: #333333;
          }
        }
        .center {
          width: 1px;
          height: 60px;
          background: #eeeeee;
          -webkit-transform: scaleY(0.5);
          transform: scale(0.5);
          -webkit-transform-origin: 0 0;
          transform-origin: 0 0;
          margin-top:34px;
        }
      }
    }
    .list_title {
      width: 100%;
      display: flex;
      display: -webkit-flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      margin-top: 20px;

      .list_left {
        span:nth-child(1) {
          font-size: 18px;
          color: #4b77b0;
        }
        span:nth-child(2) {
          font-size: 13px;
          color: #ccc;
        }
      }
      .list_right {
        span:nth-child(1) {
          font-size: 18px;
        }
        span:nth-child(2) {
          padding: 0 10px;
          font-size: 18px;
          color: #4b77b0;
        }
      }
    }
    .reject {
      width: 100%;
      background-color: #fafafa;
      padding-bottom: 16px;
      .reject_item {
        margin-left: 12px;
        margin-right: 12px;
        box-sizing: border-box;
        background-color: #ffffff;
        box-shadow: 0px 5px 10px 5px rgba(0, 0, 0, 0.04);
        border-radius: 3px;
        .item_box {
          padding: 16px;
          .title_text {
            font-size: 16px;
            font-weight: 700;
            color: #2a2a2a;
            line-height: 1.3em;
            // margin-bottom: 16px;
          }
          .info {
            margin-top: 12px;
            span:nth-child(1) {
              display: inline-block;
              width: 65px;
              font-size: 14px;
              color: #777;
              vertical-align: top;
            }
            span:nth-child(2) {
              display: inline-block;
              width:74%;
              font-size: 14px;
              color: #777;
              margin-left: 12px;
              vertical-align: top;
            }
            .orign{
              line-height: 1.3em;
            }
            .t_orign{
              line-height: 1.3em;
            }
          }
        }

        .line {
          width: 100%;
          height: 1px;
        }
        .status {
          width: 100%;
          padding: 15px 16px;
          display: flex;
          display: -webkit-flex;
          align-items: center;
          justify-content: space-between;
          align-items: center;
          .left{
            font-size:14px;
            color:#333;
          }
          .right{
            display: flex;
            display: -webkit-flex;
            flex-direction: row;
            align-items: center;
            img{
              width:4px;
              height:7px;
              margin-left:4px;
              margin-top:-3px;
            }
            span{
               font-size:12px;
               color:#999;

            }
          }

        }
      }
      .space {
        width: 100%;
        height: 24px;
        background-color: #fafafa;
      }
    }
  }
  .box1 {
    text-align: center;
    margin-top: 64px;
    img {
      display: inline-block;
      width: 72px;
      height: 64px;
    }
    .tip1 {
      font-size: 14px;
      color: #9b9b9b;
      margin-top: 28px;
    }
    .tip2 {
      font-size: 14px;
      color: #9b9b9b;
      margin-top: 8px;
    }
  }
  .go_home {
    position: fixed;
    right: 0;
    top: 538px;
    width: 59px;
    height: 59px;
    background-color: #e4f5ff;
    padding: 9px 10px 9px 9px;
    border-radius: 29px 0 0 29px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
